import { render } from "./InfoBoxes.vue?vue&type=template&id=37bf5e81"
import script from "./InfoBoxes.vue?vue&type=script&lang=js"
export * from "./InfoBoxes.vue?vue&type=script&lang=js"

import "./InfoBoxes.vue?vue&type=style&index=0&id=37bf5e81&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__